import React from "react";
import withFosRouter from "../FosRouter/withFosRouting";
import withTranslator from "../Translator/withTranslation";
import { compose } from "recompose";

var currencies = ['EUR','GBP','CHF','SEK','NOK','DKK','USD'];

class CurrencySelectorComponent extends React.Component {
    constructor(props) {
        super(props); 
    }
    
    change(value){
        const { r } = this.props;
        var url = r('select_currency', {'currency' : value});
        fetch(url, { 
                method: 'POST' 
            }).then(function (response) { 
                return response.text()
            }).then(function (data) {
                window.location.href = window.location.href.split('#')[0];
            }).catch(function(error) {
                
            });
    }

    options = () => { 
        const Options = currencies.map((item, key) =>
            <option value={item} key={key}>{item}</option>
        );

        return Options;
    }
    
    render() {
        const options = this.options();
        const { mobile, t } = this.props;
        
        return (
            mobile ? 
                <select 
                    id="CurrencySelector" 
                    className={this.props.className} 
                    style={this.props.style} 
                    onChange={(el) => this.change(el.currentTarget.value)}
                    value={this.props.currency.code}>
                    {options}
                </select>
            :
            <div className="flex items-center bor-blue1 bor-thin bor-solid border-radius-default">
                <div className="blue3 font-w600 pl-2 " style={{marginLeft: "0.2em"}}>€</div>
                <label htmlFor="CurrencySelector" className="hide">{t('currency')}</label>    
                <select 
                    id="CurrencySelector" 
                    className={this.props.className} 
                    style={this.props.style} 
                    onChange={(el) => this.change(el.currentTarget.value)}
                    value={this.props.currency.code}>
                    {options}
                </select>
            </div>
        );
    }
}

export const CurrencySelector = compose(
    withFosRouter,
    withTranslator
)(CurrencySelectorComponent);
